import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./../home/HomeCategory.css";
import ReactRoundedImage from "react-rounded-image";
import { getCategories } from "../../functions/category";
import laptop from "../../images/laptop.png";
import './cardsStyle.css'
import { useMediaQuery } from 'react-responsive'
import { cloudinaryConverter, currencyFormatterWithMultiplier } from "../../Utils/helper";

const CategoryCard = ({ category }) => {

    const [categories, setCategories] = useState([]);
    const [currency, setCurrency] = useState("INR");
    const [currencyMultiplier, setCurrencyMultiplier] = useState(1); // Default multiplier

    useEffect(() => {
        // Retrieve currency and multiplier from localStorage
        const storedCurrency = localStorage.getItem("currency") || "INR";
        const storedMultiplier = parseFloat(localStorage.getItem("currencyMultiplier")) || 1;
        setCurrency(storedCurrency);
        setCurrencyMultiplier(storedMultiplier);
    }, []);

    const { lowestPrice, productImage } = category;
    const { name, images, slug, } = category.subDetails;

    const isMobile = useMediaQuery({ query: '(max-width: 700px' })
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 749px)' })



    return (
        <>
            <div className="cat-thumb puffAnim c-category c-category__ordinary c-category__initial" >
                <div className="c-category__size-spacer" />
                <div className="puffFill c-category__item-wrap" style={{ backgroundColor: 'rgb(0, 164, 255)', borderColor: 'rgb(0, 164, 255)' }}>
                    <div className="c-category__img-wrap">
                        <Link to={"/sub/" + slug} className="nostyle"> <img src={images && images.length ? images[0].url : productImage ? productImage.url : laptop} alt={name} width={isTabletOrMobile ? 170 : 300} height={isTabletOrMobile ? 110 : 300} className={isTabletOrMobile ? "puffAnim" : "c-category__square-icon puffAnim"} />
                        </Link>
                    </div>
                    <div className="cat-label-container" >
                        <div className="puffAnimFaster itemReveal fadeIn cat-label" style={{ backgroundColor: 'rgb(0, 164, 255)' }}>{name}</div>
                    </div>

                    <div className="cat-label-container-bottom">
                        <div className="puffAnimFaster itemReveal fadeIn cat-label" style={{ backgroundColor: 'rgb(0, 164, 255)' }}>
                            Starts {currencyFormatterWithMultiplier(lowestPrice * currencyMultiplier, currency)}
                        </div>
                    </div>


                </div>
            </div>
        </>





    );
};

export default CategoryCard;